<template>
    <div class="person-container">
        <div class="person-wrapper" v-for="person in this.$i18n.t('cast.people')">
            <div class="person">
                <img :src="image(person)">
                <span class="name">{{person.name}} {{person.surname}}</span>
                <span class="role">{{person.role}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    let images = require.context("../../assets/img/crew_cast/", true, /\.jpg$/);

    export default {
        name: 'group-cast',
        methods: {
            image: function (person) {
                return images('./' + this.$i18n.t('cast.folder') + '/' + person.surname.replace(' ', '-') + '-' + person.name.replace(' ', '-') + '.jpg');
            },
        },
        data: function () {
        return {};
      }
    }
</script>

<style lang="scss">
    @import "../../assets/scss/person";
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupCast.vue